export default __webpack_public_path__ + "static/media/quote-mobile.57943492.jpg";